/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit OrientationAction/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaButton from 'DesignSystem/TysiaButton/index'
import TysiaButtonText from 'DesignSystem/TysiaButton/TysiaButtonText/index'



/** @type {import('Simple/types.js').View} */
export default function OrientationAction({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/TreatmentCard/Content/TreatmentCard/Images/ActiveTab/Images/Content/Content/Content/Comparison/Content/Orientation/OrientationAction"
  
}) {
let imagesComparisonSectionsOrientationValueData = fromData.useDataValue({ viewPath,
context: 'images_comparison_sections',
path: 'orientation',
})
let orientationIdValueData = fromData.useDataValue({ viewPath,
context: 'orientation',
path: 'id',
})
let aggregateData = fromAggregate.equals(imagesComparisonSectionsOrientationValueData, orientationIdValueData)
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let onClick = fromHelpers.useOnChange({
  children,
  viewPath
  
})
let orientationTextValueData = fromData.useDataValue({ viewPath,
context: 'orientation',
path: 'text',
})
  return (<React.Fragment
>
<TysiaButton
  viewPath={`${viewPath}/TysiaButton`}
 type="secondary"
 onClick={onClick}
 width={150}
 paddingBottom={dtSpaceXxs}
 marginLeft={dtSpaceXs}
 paddingTop={dtSpaceXxs}
 data="images_comparison_sections.orientation"
 data="orientation.id"
 aggregate="/Data/aggregate.js equals"
 selected={aggregateData}
>
{childProps => (
<TysiaButtonText
{...childProps}
  viewPath={`${viewPath}/TysiaButtonText`}
 data="orientation.text"
 text={orientationTextValueData}
/>
)}
</TysiaButton>
{children}
</React.Fragment>)
}